import { ReactNode, useCallback, useEffect, useState } from "react";
import ErrorModal from "./ErrorModal";
import logger from "../../libs/errorLib";
import { UserError } from "@fableous/core/model/BasicError";
import { GlobalEventEmitter } from "../../libs/eventLib";

export default function ErrorManager({ children }: { children: ReactNode }) {
	const [error, setError] = useState<unknown | undefined>(undefined);
	const [userAckFnc, setUserAckFnc] = useState<() => void>();

	useEffect(() => {
        GlobalEventEmitter.on("error", setError);
		return () => {
			GlobalEventEmitter.off("error", setError);
		};
	}, []);

	const resetErrorState = useCallback(() => {
		setError(undefined);
	}, []);

	useEffect(() => {
		setUserAckFnc(function () {
			return resetErrorState;
		});
	}, [resetErrorState]);

	useEffect(() => {
		if (error && !(error instanceof UserError)) {
			logger.error(error);
		}
	}, [error]);

	return (
        <>
            {error !== undefined && (
                <ErrorModal error={error} userAckFnc={userAckFnc}></ErrorModal>
            )}
            {children}
        </>
	);
}
